import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import App from './App'
import { ErrorStep } from './steps/error/ErrorStep'
import { sendErrorLog } from './clients/logClient'
import { ErrorLogSource } from './@types/errorLog'

const appErrorHandler = (error: Error, info: { componentStack: string }) => {
  sendErrorLog({
    message: `Error while rendering wizard, error: ${error.name} ${error.message}, stack: error: ${error.stack} componentStack: ${info.componentStack}`,
    source: ErrorLogSource.ERROR_BOUNDARY,
  })
}

export const AppWithErrorBoundary: React.FC = () => (
  <ErrorBoundary FallbackComponent={() => <ErrorStep />} onError={appErrorHandler}>
    <App />
  </ErrorBoundary>
)
